export type { INJECTED_ENVIRONMENT } from './lib/type/injected-environment';
export { getEnvironment } from './lib/type/injected-environment';
